import { render, staticRenderFns } from "./FornecedoresDash.vue?vue&type=template&id=025743d2"
import script from "./FornecedoresDash.vue?vue&type=script&lang=js"
export * from "./FornecedoresDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports